var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20317 2.05088C7.60332 1.52315 8.39668 1.52315 8.79683 2.05088L9.52168 3.00682C9.74002 3.29477 10.0967 3.44253 10.4547 3.3933L11.6432 3.22989C12.2993 3.13968 12.8603 3.70067 12.7701 4.35678L12.6067 5.54528C12.5575 5.90328 12.7052 6.25998 12.9932 6.47832L13.9491 7.20317C14.4769 7.60332 14.4769 8.39668 13.9491 8.79683L12.9932 9.52168C12.7052 9.74002 12.5575 10.0967 12.6067 10.4547L12.7701 11.6432C12.8603 12.2993 12.2993 12.8603 11.6432 12.7701L10.4547 12.6067C10.0967 12.5575 9.74002 12.7052 9.52168 12.9932L8.79683 13.9491C8.39668 14.4769 7.60332 14.4769 7.20317 13.9491L6.47832 12.9932C6.25998 12.7052 5.90328 12.5575 5.54528 12.6067L4.35678 12.7701C3.70067 12.8603 3.13968 12.2993 3.22989 11.6432L3.3933 10.4547C3.44253 10.0967 3.29477 9.74002 3.00682 9.52168L2.05088 8.79683C1.52315 8.39668 1.52315 7.60332 2.05088 7.20317L3.00682 6.47832C3.29477 6.25998 3.44253 5.90328 3.3933 5.54528L3.22989 4.35678C3.13968 3.70067 3.70067 3.13968 4.35678 3.22989L5.54528 3.3933C5.90328 3.44253 6.25998 3.29477 6.47832 3.00682L7.20317 2.05088Z",
    fill: "url(#paint0_linear_14_4158)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_14_4158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.20317 1.05088C8.60332 0.523149 9.39668 0.523148 9.79683 1.05088L10.5217 2.00682C10.74 2.29477 11.0967 2.44253 11.4547 2.3933L12.6432 2.22989C13.2993 2.13968 13.8603 2.70067 13.7701 3.35678L13.6067 4.54528C13.5575 4.90328 13.7052 5.25998 13.9932 5.47832L14.9491 6.20317C15.4769 6.60332 15.4769 7.39668 14.9491 7.79683L13.9932 8.52168C13.7052 8.74002 13.5575 9.09672 13.6067 9.45472L13.7701 10.6432C13.8603 11.2993 13.2993 11.8603 12.6432 11.7701L11.4547 11.6067C11.0967 11.5575 10.74 11.7052 10.5217 11.9932L9.79683 12.9491C9.39668 13.4769 8.60332 13.4769 8.20317 12.9491L7.47832 11.9932C7.25998 11.7052 6.90328 11.5575 6.54528 11.6067L5.35678 11.7701C4.70067 11.8603 4.13968 11.2993 4.22989 10.6432L4.3933 9.45472C4.44253 9.09672 4.29477 8.74002 4.00682 8.52168L3.05088 7.79683C2.52315 7.39668 2.52315 6.60332 3.05088 6.20317L4.00682 5.47832C4.29477 5.25998 4.44253 4.90328 4.3933 4.54528L4.22989 3.35678C4.13968 2.70067 4.70067 2.13968 5.35678 2.22989L6.54528 2.3933C6.90328 2.44253 7.25998 2.29477 7.47832 2.00682L8.20317 1.05088Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_14_4158",
    x: 0.755029,
    y: -1.24497,
    width: 16.4899,
    height: 16.4899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_14_4158"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_14_4158",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_4158",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23D7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79FFCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3ae50825dc01c96c714d4d5dbc3033df.svg";
export { ForwardRef as ReactComponent };